// extracted by mini-css-extract-plugin
export default {"menu":"_2nM4RO1WqLK8gs4KH-2z2F","linkDropdown":"_1esoAiKQrXlwWWXR-9LEMI"};